<div class="w-full h-full relative bg-background-secondary">
  <div class="pl-3 pr-3 pt-2 search-modal" style="height: 60px">
    <mat-form-field [style.fontSize]="'12px'" class="w-full grid-row-search">
      <mat-label>Search on Canvas</mat-label>
      <input
        maxlength="30"
        placeholder="Search for Name, Type, etc."
        autocomplete="off"
        matInput
        id="searchInput"
        [(ngModel)]="searchKey"
        [attr.data-test]="'canvas-input-search-node'"
      />
      <div matPrefix>
        <fa-icon [icon]="['fal', 'search']" class="mr-1 relative text-gray-600"></fa-icon>
      </div>
      <div matSuffix *ngIf="searchKey && searchKey.length > 0" class="relative">
        <button
          class="small-icon-button"
          mat-icon-button
          (click)="searchKey = ''"
          [intercomTarget]="'01-search-gojs-modal-98963'"
          [attr.data-test]="'canvas-input-clear-search'"
        >
          <fa-icon class="fs-8" [icon]="['fal', 'times']"></fa-icon>
        </button>
      </div>
    </mat-form-field>
  </div>
  <div style="height: calc(100% - 60px)">
    <div class="h-full overflow-auto">
      <mat-selection-list
        class="w-full p-0"
        [multiple]="false"
        *ngIf="searchNodes.length > 0"
        (selectionChange)="onSelectionChanged($event)"
      >
        <div *ngIf="searchNodes.length > 0; else noResultsFound">
          <mat-list-option
            class="p-0"
            style="height: 55px"
            *ngFor="let node of searchNodes | gojsSearchNodeFilter : searchKey; trackBy: trackByKey"
            [value]="node.key"
          >
            <div class="p-0 aligner-start node-container w-full">
              <div class="p-0 aligner" style="width: 75px">
                <div
                  class="node-icon"
                  [style.backgroundColor]="'transparent'"
                  [style.borderColor]="'#c6c6c6'"
                  [matTooltip]="node.nodeType"
                >
                  <img width="20" [src]="node.nodeTypeIcon || NotFoundIcon" />
                </div>
              </div>
              <div class="truncate" style="height: calc(100% - 90px)" *ngIf="node.nodeType; else notFound">
                <div
                  *ngIf="node.entityName"
                  class="node-title"
                  [attr.data-test]="'canvas-node-type-' + node.entityName"
                >
                  <img class="mr-2" width="12" height="12" [src]="node.entityTypeIcon" />
                  <span [innerHTML]="node.entityName | searchHighlight : searchKey"></span>
                </div>
                <div class="node-description" [attr.data-test]="'canvas-node-title-' + node.subEntityName">
                  <img *ngIf="node.entityName" class="mr-2" width="15" height="15" [src]="node.subEntityTypeIcon" />
                  <span [innerHTML]="node.subEntityName | searchHighlight : searchKey"></span>
                </div>
              </div>
              <ng-template #notFound>
                <div class="truncate text-gray-700 text-xs" style="height: calc(100% - 90px)">
                  {{ NotFoundPlaceholder }}
                </div>
              </ng-template>
            </div>
          </mat-list-option>
        </div>
      </mat-selection-list>
    </div>
  </div>
</div>

<ng-template #noResultsFound>
  <div class="p-3 pt-5 fs-1 font-medium aligner flex-col w-full">
    <img src="assets/images/not-available/no-filter-result.svg" alt="" width="80" class="mb-2" />
    No Results Found
  </div>
</ng-template>
